<template>
  <el-button
    v-if="isShow"
    :size="this.size"
    :type="this.type"
    :plain="this.plain"
    :round="this.round"
    :circle="this.circle"
    :loading="this.loading"
    :disabled="this.disabled"
    :icon="this.icon"
    :autofocus="this.autofocus"
    :native-type="this.nativeType"
    @click="handleClick"
  >
    {{label}}
  </el-button>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    size: { type: String, default: 'medium' },
    type: { type: String, default: '' },
    plain: { type: Boolean, default: false },
    round: { type: Boolean, default: false },
    circle: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: { Type:String, default: '' },
    autofocus: { type: Boolean, default: false },
    nativeType: { type: String, default: 'button' },
    label: { type: String, default: '' },
    href: { type: String, default: '' },
    granted: { type: Function, default: () => {} }
  },
  computed: {
    isShow(){
      return this.granted(this.ac)
    },
    ...mapGetters([ 'ac' ])
  },
  methods: {
    handleClick() {
      if (this.href) {
        this.$router.push(this.href)
      } else {
        this.$emit('click')
      }
    },
  }
}
</script>